const url = '/price-levels';
const Provider = 'PriceLevels';
const dbModel = 'PriceLevels';

export { url, Provider, dbModel };
